module.exports = __webpack_public_path__ + "img/6.976815b6.svg";